export const formatNumber = (number = 0) => {
  return String(Number(number) || 0).replace(".", ",");
};
